import React from 'react'

import {styled, useTheme} from '@mui/material/styles'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle'
import useMediaQuery from "@mui/material/useMediaQuery";

const StyledDialog = styled(Dialog)`
  ${({theme}) => `
    
  `}
`

export default function DeleteConfirmationDialog(props) {

	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('md'))

	const {onCancel, onConfirm} = props

	return (
		<StyledDialog open onClose={onCancel}>
			<DialogTitle>Are you confirm to delete this admin account</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Are you sure to delete this admin account information?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button fullWidth={isMobile} variant={'outlined'} onClick={onCancel}>Cancel</Button>
				<Button fullWidth={isMobile} color={'error'} variant={'outlined'} onClick={onConfirm}>Confirm delete</Button>
			</DialogActions>
		</StyledDialog>
	)
}
